export const norm = (s) =>
  (s || '')
    .toLowerCase()
    .replace(/ç/g, 'c').replace(/ğ/g, 'g').replace(/ı/g, 'i')
    .replace(/ö/g, 'o').replace(/ş/g, 's').replace(/ü/g, 'u')
    .replace(/[^a-z0-9\s]/g, '')
    .replace(/\s+/g, ' ')
    .trim();

export const stopWords = new Set([
  'park','parki','ve','ile','de','da','belediyesi','belediye','buyuksehir',
  'caddesi','cadde','cad','sokak','sok','mahallesi','mahalle','mah',
  'bulvari','bahce','bahcesi','ankara','cankaya','yesil','alan',
  'bld','bsk','prk','bah','mud','cev','kor','dai','ser',
  'abb','rekreasyon','alani',
]);

export const sigWords = (s) =>
  norm(s).split(' ').filter(w => w.length > 2 && !stopWords.has(w));

export const extractAskiParkName = (aboneAdi) =>
  (aboneAdi || '')
    .replace(/^ANK\.?B\.?B\.?B\.?\s*/i, '')
    .replace(/^[A-ZÇĞİÖŞÜa-zçğıöşü.]+\s*BEL(EDİYESİ|\.?)\s*/i, '')
    .replace(/^ÇEV\.?KOR\.?DAİ?\.?B[ŞS^]K\.?\s*/i, '')
    .replace(/PARK\s*BAH\.?\s*MÜD\.?\s*(SE\s*RA)?/i, '')
    .replace(/\s+/g, ' ')
    .trim();

const calcJaccardScore = (words1, words2) => {
  if (words1.length === 0 || words2.length === 0) return 0;
  const set1 = new Set(words1);
  const set2 = new Set(words2);
  const common = words1.filter(w => set2.has(w));
  if (common.length === 0) return 0;
  const union = new Set([...set1, ...set2]);
  let score = common.length / union.size;
  if (common.length === 1 && union.size > 2) score *= 0.5;
  return Math.round(score * 100) / 100;
};

export const buildComparison = (askiParks, dbParkList, exParks) => {
  const askiIlceler = {};
  askiParks.forEach(a => {
    const ilce = a.ilce_adi || 'Bilinmiyor';
    askiIlceler[ilce] = (askiIlceler[ilce] || 0) + 1;
  });
  const askiCankaya = askiParks.filter(a => norm(a.ilce_adi || '').includes('cankaya'));

  const exNormIndex = {};
  exParks.forEach(p => { exNormIndex[norm(p.adi)] = p; });
  const dbNormMap = {};
  dbParkList.forEach(d => {
    const nk = norm(d.name_kmz || '');
    const nx = norm(d.name_xls || '');
    if (nk) dbNormMap[nk] = d;
    if (nx) dbNormMap[nx] = d;
  });

  let exDbExact = 0, exDbPartial = 0;
  const exDbMatches = [];
  const askiNormIndex = {};
  askiCankaya.forEach(a => {
    askiNormIndex[norm(extractAskiParkName(a.abone_adi))] = a;
  });

  exParks.forEach(ep => {
    const en = norm(ep.adi);
    const askiMatch = askiNormIndex[en] || null;
    if (dbNormMap[en]) {
      const d = dbNormMap[en];
      exDbExact++;
      exDbMatches.push({ excel: ep.adi, db: d.name_kmz || d.name_xls, type: 'tam', excelData: ep, dbData: d, askiData: askiMatch });
      return;
    }
    const ew = sigWords(ep.adi);
    if (ew.length === 0) return;
    let bestScore = 0, bestDb = null, bestCommon = [];
    for (const [dn, d] of Object.entries(dbNormMap)) {
      const dw = sigWords(dn);
      const score = calcJaccardScore(ew, dw);
      if (score > bestScore) {
        bestScore = score;
        bestDb = d;
        bestCommon = ew.filter(w => new Set(dw).has(w));
      }
    }
    if (bestScore >= 0.5 && bestDb) {
      exDbPartial++;
      exDbMatches.push({ excel: ep.adi, db: bestDb.name_kmz || bestDb.name_xls, type: 'benzer', ortak: bestCommon.join(', '), excelData: ep, dbData: bestDb, askiData: askiMatch });
    }
  });

  let askiExExact = 0, askiExPartial = 0;
  const askiExMatches = [];
  askiCankaya.forEach(a => {
    const extracted = extractAskiParkName(a.abone_adi);
    const en = norm(extracted);
    if (exNormIndex[en]) {
      const ep = exNormIndex[en];
      askiExExact++;
      askiExMatches.push({ aski: a.abone_adi, extracted, type: 'tam', askiData: a, excelData: ep });
      return;
    }
    const aw = sigWords(extracted);
    if (aw.length === 0) return;
    let bestScore = 0, bestEp = null, bestCommon = [];
    for (const ep of exParks) {
      const ew = sigWords(ep.adi);
      const score = calcJaccardScore(aw, ew);
      if (score > bestScore) {
        bestScore = score;
        bestEp = ep;
        bestCommon = aw.filter(w => new Set(ew).has(w));
      }
    }
    if (bestScore >= 0.5 && bestEp) {
      askiExPartial++;
      askiExMatches.push({ aski: a.abone_adi, extracted, excel: bestEp.adi, type: 'benzer', ortak: bestCommon.join(', '), askiData: a, excelData: bestEp });
    }
  });

  return {
    askiTotal: askiParks.length, askiIlceler, askiCankayaCount: askiCankaya.length,
    dbTotal: dbParkList.length, exTotal: exParks.length,
    exDbExact, exDbPartial, exDbMatches,
    askiExExact, askiExPartial, askiExMatches,
  };
};
